<template>
    <el-form :model="formData" :rules="formRules" label-position="top">
        <el-form-item label="事件名称" prop="name">
            <div>{{ formData.name }}</div>
        </el-form-item>
        <el-form-item label="事件分类" prop="eventTypeId">
            <div>{{ formData.parentEventTypeName }}/{{ formData.eventTypeName }}</div>
        </el-form-item>
        <el-form-item label="发现时间" prop="happenTime">
            <div>{{ formData.happenTime }}</div>
        </el-form-item>
        <el-form-item label="经纬度" prop="longitude">
            <LngLatInput
                size="small"
                :longitude.sync="formData.longitude"
                :latitude.sync="formData.latitude"
                readonly
            >
                <el-button slot="append" size="small" type="primary" @click="amapVisible = true"
                    >查看</el-button
                >
            </LngLatInput>

            <CAmap
                :visible.sync="amapVisible"
                :markerPosition="[formData.longitude, formData.latitude]"
                :categoryFormData='formData'
                type='see'
                coordType="wgs84"
                :enablePick="false"
            ></CAmap>
        </el-form-item>
        <el-form-item label="区域">
            <div>{{ getArea(formData.areaId) }}</div>
        </el-form-item>
        <!-- <el-form-item label="辖区">
            <div>{{ getJurisdiction(formData.jurisdictionId) }}</div>
        </el-form-item> -->
        <el-form-item label="地址">
            <div>{{ formData.address }}</div>
        </el-form-item>
        <el-form-item label="发现人" prop="happenBy">
            <div>{{ formData.happenBy }}</div>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
            <div>{{ formData.phone }}</div>
        </el-form-item>
        <el-form-item label="采集设备" prop="collectDevice">
            <div>{{ formData.collectDevice }}</div>
        </el-form-item>
        <el-form-item label="事件描述" prop="remark">
            <div>{{ formData.remark }}</div>
        </el-form-item>
    </el-form>
</template>

<script>
import LngLatInput from '../../LngLatInput/LngLatInput.vue';
import CAmap from '../../CAmap/CAmap.vue';

export default {
    components: {
        LngLatInput,
        CAmap,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            },
        },
        rules: {
            type: Object,
            default() {
                return {};
            },
        },
        areaList: {
            type: Array,
            default() {
                return [];
            },
        },
        jurisdictionList: {
            type: Array,
            default() {
                return [];
            },
        },

    },
    data() {
        return {
            formData: this.data,
            formRules: this.rules,
            amapVisible: false,
        };
    },
    computed: {},
    methods: {
        getArea(val) {
            let area = this.areaList[0].children.find((item) => item.id === val);
            return `${this.areaList[0].text}/${area.text}`;
        },
        getJurisdiction(val) {
            let jurisdiction = this.jurisdictionList.find((item) => item.id === val);
            return `${jurisdiction ? jurisdiction.name : '-'}`;
        },
    },
    created() {},
    mounted() {},
    watch: {
        data(val) {
            this.formData = val;
            console.log(val);
        },
        rules(val) {
            this.formRules = val;
        },
    },
};
</script>

<style lang="scss" scoped></style>
